export default "__VITE_ASSET__B2eV_xFX__"